import React from 'react';
import { MDBFooter, MDBContainer, MDBRow, MDBCol, MDBIcon, MDBNavbarBrand } from 'mdb-react-ui-kit';
import logo from "../../assets/logo_fsky.png";
import './footer.css'; // Make sure to create a Footer.css file or use inline styles as well

export default function App() {
  return (
    <MDBFooter className='text-center text-lg-start text-muted' style={{ background:"#495d4b" }}>
      <section className='' style={{ marginTop:"20px"}}>
        <MDBContainer className='text-center text-md-start mt-5'>
          <MDBRow className='mt-3'>
            <MDBCol md="3" lg="4" xl="3" className='mx-auto '>
              <h5 className='text-uppercase fw-bold mb-4 text-white-footer' style={{ fontSize:"18px", marginTop:"10px"}}>
                {/* <MDBNavbarBrand href="#">
                  <img src={logo} alt="Logo" className="me-3" style={{ width: "40px", height: "40px" }} />
                </MDBNavbarBrand> */}
                First Sky Infra
              </h5>
              <p className="text-white-footer" style={{ textIndent:"10px", textAlign:"justify"}}>
              We specialize in complete turnkey interior  services, ensuring a seamless experience from concept to completion.
               {/* With 32 successfully completed projects, we have built a reputation for quality, efficiency, and innovation. */}
              </p>
            </MDBCol>

            <MDBCol md="2" lg="2" xl="2" className='mx-auto '>
              <h5 className='text-uppercase fw-bold mb-4 text-white-footer' style={{ fontSize:"18px", marginTop:"10px"}}> Our Links</h5>
              <div className="footer-links">
                <p><i className="fa fa-angle-double-right"></i> &nbsp;
                  <a href='/interiorpage' className='text-reset'>Home</a>
                </p>
                <p><i className="fa fa-angle-double-right"></i> &nbsp;
                  <a href='/portfoliopage' className='text-reset'>Portfolio</a>
                </p>
                <p><i className="fa fa-angle-double-right"></i> &nbsp;
                  <a href='/architecture' className='text-reset'>Architecture</a>
                </p>
                <p><i className="fa fa-angle-double-right"></i> &nbsp;
                  <a href='/projectmanagement' className='text-reset'>Project </a>
                </p>
              </div>
            </MDBCol>

            <MDBCol md="3" lg="2" xl="2" className='mx-auto '>
              <h5 className='text-uppercase fw-bold mb-4 text-white-footer' style={{ fontSize:"18px",  marginTop:"10px"}}>We Serve</h5>
              <div className="footer-links">
                <p><i className="fa fa-angle-double-right"></i> &nbsp;
                  <a href='/interiorpage' className='text-reset'>Chennai</a>
                </p>
                
                <p><i className="fa fa-angle-double-right"></i> &nbsp;
                  <a href='/interiorpage' className='text-reset'>Bangalore</a>
                </p>
                <p><i className="fa fa-angle-double-right"></i> &nbsp;
                  <a href='/interiorpage' className='text-reset'>Hyderabad</a>
                </p>
                <p><i className="fa fa-angle-double-right"></i> &nbsp;
                  <a href='/interiorpage' className='text-reset'>Kerala</a>
                </p>  
                <p><i className="fa fa-angle-double-right"></i> &nbsp;
                  <a href='/interiorpage' className='text-reset'>Andhra Pradesh</a>
                </p>
              </div>
            </MDBCol>

            <MDBCol md="3" lg="3" xl="3" className='mx-auto  '>
              <h5 className='text-uppercase fw-bold mb-4 text-white-footer'style={{ fontSize:"18px", textAlign:"center",  marginTop:"10px"}} >Contact</h5>
              <p className="text-white-footer">
                {/* <MDBIcon icon="home" className="me-2" /> */}
               No:21, Vinayaga nagar, Okkiyam Thoraipakkam, Chennai-97
                
              </p>
              <p className="text-white-footer">
                {/* <MDBIcon icon="envelope" className="me-3" /> */}
                info@firstskyinfra.in
              </p>
              <p className="text-white-footer">
                {/* <MDBIcon icon="phone" className="me-3" /> */}
                +91 9500167678,  044-48570414
              </p>
            
            </MDBCol>
          </MDBRow>
        </MDBContainer>
      </section>

      <div className='text-center p-2 text-white-footer' style={{ backgroundColor: 'rgba(0, 0, 0, 0.05)', borderTop:"1px solid white" }}>
        © 2025 Copyright:
        <a className='text-reset fw-bold' href='https://www.firstskyinfra.in/' target='_blank'>
         First Sky Infra
        </a>
      </div>
    </MDBFooter>
  );
}
